import { z } from 'zod';
export var RevenueShareEligibilityStatus;
(function (RevenueShareEligibilityStatus) {
    RevenueShareEligibilityStatus["Eligible"] = "Eligible";
    RevenueShareEligibilityStatus["NotEligible"] = "NotEligible";
})(RevenueShareEligibilityStatus || (RevenueShareEligibilityStatus = {}));
// TODO: Remove booleans isFeaturedTemplate and hasThumbnail and use featuredTimestamp and isDefined(thumbnailUrl) instead.
export const FlowDefinitionTemplateMetadataSchema = z.object({
    caseStudy: z
        .object({
        title: z.string(),
        hyperlinkUrl: z.string(),
        imageUrl: z.string(),
    })
        .optional(),
    isFeaturedTemplate: z.boolean().optional(),
    featuredTimestamp: z.string().optional(),
    hasThumbnail: z.boolean().optional(),
    overview: z.string().optional(),
    revenueShareEligibilityStatus: z.enum(RevenueShareEligibilityStatus).optional(),
});
//# sourceMappingURL=metadata.js.map